import { ReactComponent as IconShirtIndividual } from "assets/svg/shirt-individual.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const merchConnections: SurveyTemplate = {
  icon: <IconShirtIndividual />,
  title: "Merch Connections",
  description:
    "Ask fans to share a story about how wearing their merch connected them to others.",
  templateId: "merchConnections",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Merch Connections",
        },
      },
      ...getContestDefaults(formState),
    },
    surveyQuestions: [
      {
        type: "TextQuestion",
        id: "question_1",
        multiline: true,
      },
    ],
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-merch---me-f879ea"
        : "pp-merch---me-e467b7",
    fields: [
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
